/* Wynwood feeding math. ONE COPY. Everything that turns a dog into a portion
   lives here and nowhere else.

   Pure functions only. No DOM, no fetch, no diet data. Callers pass the diet
   in, and callers do their own rendering. The finder's ranking engine stays
   in the finder; this file has no opinion about which diet suits a dog.

   window.wynFeed.plan(profile, diet, opts) is the one call most callers want.
*/
(function () {
  'use strict';

  var CFG = {
    RER_COEF: 70,
    RER_EXP: 0.75,
    /* Fresh food: feed 15% fewer label calories (0.85; 0.8 until 2026-10-11).
       A house setting. Label calories are usually worked out with a formula
       built around kibble, which undercounts what a dog gets from fresh,
       gently cooked food. A caller feeding something that is not fresh
       passes profile.fresh = false. */
    FRESH_FACTOR: 0.85,
    LB_PER_KG: 2.2046226218,
    G_PER_OZ: 28.349523125,

    ACTIVITY: { low: 1.2, normal: 1.55, high: 1.75 },
    ACTIVITY_DEFAULT: 'normal',

    /* Settled 2026-08-05: the factor exists on every surface and defaults to
       neutered, so only an intact dog reads differently from before. Which
       surfaces expose a control is a UI question, not a math one. */
    NEUTER: { neutered: 1, intact: 1.125 },
    NEUTER_DEFAULT: 'neutered',

    /* Age is bucketed by MONTHS. Callers holding a bare factor (the product
       page reads one off the stored profile) can pass ageFactor instead. */
    AGE_BUCKETS: [
      { max: 3, factor: 2 },
      { max: 6, factor: 1.5 },
      { max: 12, factor: 1.25 },
      { max: 84, factor: 1 },
      { max: Infinity, factor: 0.9 }
    ],
    AGE_MONTHS_DEFAULT: 48,

    /* Diets fed deliberately below maintenance. The reduction must ALWAYS be
       stated wherever it applies - plan() returns it so a caller cannot
       silently swallow it. */
    DIET_FACTORS: { 'weight + mobility': 0.9 },

    /* Share of the dog's food that is Wynwood. */
    PORTIONS: { full: 100, half: 50, topper: 25 },
    PORTION_DEFAULT: 100,

    /* Quarter ounces everywhere, per day and per meal, so an ounce figure is
       only ever whole, 1/4, 1/2 or 3/4. */
    ROUND_OZ: 0.25,
    ROUND_CUP_DAY: 4,
    ROUND_CUP_MEAL: 8,

    SPLIT_3_CUPS: 8,
    TRANSITION: [
      { days: 'Days 1 - 3', pct: 25 },
      { days: 'Days 4 - 6', pct: 50 },
      { days: 'Days 7 - 9', pct: 75 },
      { days: 'Day 10 +', pct: 100 }
    ]
  };

  /* ---------------------------------------------------------------- math */

  function ageFactorFromMonths(months) {
    var m = Number(months);
    if (!isFinite(m) || m < 0) { m = CFG.AGE_MONTHS_DEFAULT; }
    for (var i = 0; i < CFG.AGE_BUCKETS.length; i++) {
      if (m < CFG.AGE_BUCKETS[i].max) { return CFG.AGE_BUCKETS[i].factor; }
    }
    return 1;
  }

  function resolveAge(profile) {
    if (profile && profile.ageFactor != null && isFinite(Number(profile.ageFactor))) {
      return Number(profile.ageFactor);
    }
    return ageFactorFromMonths(profile && profile.ageMonths);
  }

  function resolveActivity(profile) {
    var a = profile && profile.activity;
    if (typeof a === 'number' && isFinite(a) && a > 0) { return a; }
    if (typeof a === 'string' && CFG.ACTIVITY[a]) { return CFG.ACTIVITY[a]; }
    if (typeof a === 'string' && isFinite(Number(a)) && Number(a) > 0) { return Number(a); }
    return CFG.ACTIVITY[CFG.ACTIVITY_DEFAULT];
  }

  function resolveNeuter(profile) {
    var n = profile && profile.neuter;
    if (typeof n === 'number' && isFinite(n) && n > 0) { return n; }
    if (typeof n === 'string' && CFG.NEUTER[n]) { return CFG.NEUTER[n]; }
    return CFG.NEUTER[CFG.NEUTER_DEFAULT];
  }

  function resolveFresh(profile) {
    return (profile && profile.fresh === false) ? 1 : CFG.FRESH_FACTOR;
  }

  function resolvePortion(v) {
    if (typeof v === 'number' && isFinite(v) && v > 0) { return v; }
    if (typeof v === 'string' && CFG.PORTIONS[v]) { return CFG.PORTIONS[v]; }
    return CFG.PORTION_DEFAULT;
  }

  function dietFactor(dietKey) {
    var k = String(dietKey || '').toLowerCase();
    var f = CFG.DIET_FACTORS[k];
    return (typeof f === 'number' && f > 0) ? f : 1;
  }

  /* Maintenance calories, before any diet factor or portion share.
     NO BODY CONDITION FACTOR - settled 2026-08-05. Build informs which diet
     is recommended, never how much of it. */
  function maintenanceKcal(profile) {
    var lb = Number(profile && profile.weight_lb);
    if (!isFinite(lb) || lb <= 0) { return 0; }
    var kg = lb / CFG.LB_PER_KG;
    return CFG.RER_COEF * Math.pow(kg, CFG.RER_EXP)
      * resolveNeuter(profile)
      * resolveActivity(profile)
      * resolveAge(profile)
      * resolveFresh(profile);
  }

  /* Every factor behind maintenanceKcal(), so a screen can show its working.
     Built from the same resolvers, so it cannot disagree with the number. */
  function explain(profile) {
    var lb = Number(profile && profile.weight_lb);
    if (!isFinite(lb) || lb <= 0) { return null; }
    var kg = lb / CFG.LB_PER_KG;
    var out = {
      kg: kg,
      rer: CFG.RER_COEF * Math.pow(kg, CFG.RER_EXP),
      activity: resolveActivity(profile),
      age: resolveAge(profile),
      neuter: resolveNeuter(profile),
      fresh: resolveFresh(profile)
    };
    out.kcal = out.rer * out.neuter * out.activity * out.age * out.fresh;
    return out;
  }

  function mealsFor(profile, cups) {
    var months = (profile && profile.ageMonths != null) ? Number(profile.ageMonths) : null;
    var puppy = (months != null && months < 12) || resolveAge(profile) > 1;
    return (puppy || cups > CFG.SPLIT_3_CUPS) ? 3 : 2;
  }

  /* The one call. diet needs { key, kcal_per_kg, kcal_per_cup }. */
  function plan(profile, diet, opts) {
    opts = opts || {};
    diet = diet || {};

    var full = maintenanceKcal(profile);
    var portionPct = resolvePortion(opts.portion);
    var factor = dietFactor(diet.key);
    var kcal = full * (portionPct / 100) * factor;

    var kcalKg = Number(diet.kcal_per_kg);
    var kcalCup = Number(diet.kcal_per_cup);
    var grams = (isFinite(kcalKg) && kcalKg > 0) ? (kcal / kcalKg) * 1000 : 0;
    var oz = grams / CFG.G_PER_OZ;
    var cups = (isFinite(kcalCup) && kcalCup > 0) ? kcal / kcalCup : 0;

    var meals = opts.meals ? Number(opts.meals) : mealsFor(profile, cups);

    return {
      kcalFull: full,
      kcal: kcal,
      grams: grams,
      oz: oz,
      cups: cups,
      meals: meals,
      ozPerMeal: meals ? oz / meals : 0,
      cupsPerMeal: meals ? cups / meals : 0,
      portionPct: portionPct,
      /* percent below maintenance, 0 when the diet is fed at maintenance */
      reduction: factor === 1 ? 0 : Math.round((1 - factor) * 1000) / 10,
      transition: CFG.TRANSITION.map(function (t) {
        return { days: t.days, pct: t.pct, oz: oz * t.pct / 100, cups: cups * t.pct / 100 };
      })
    };
  }

  /* ------------------------------------------------------------ display */

  function roundTo(v, inc) { return Math.round(v / inc) * inc; }

  /* Mixed fraction. A portion that rounds to zero but is not zero shows the
     smallest step rather than "0", because "feed 0 oz" is always wrong. */
  function fmtOz(v, inc) {
    inc = inc || CFG.ROUND_OZ;
    var r = roundTo(Number(v) || 0, inc);
    if (r <= 0 && v > 0) { r = inc; }
    var den = Math.round(1 / inc);
    return mixed(Math.round(r * den), den);
  }

  function fmtCups(v, den) {
    den = den || CFG.ROUND_CUP_DAY;
    var q = Math.round((Number(v) || 0) * den);
    if (q <= 0 && v > 0) { q = 1; }
    return mixed(q, den);
  }

  function mixed(q, den) {
    if (q <= 0) { return '0'; }
    var whole = Math.floor(q / den);
    var rem = q % den;
    if (rem === 0) { return String(whole); }
    var a = rem, b = den, t;
    while (b) { t = b; b = a % b; a = t; }
    var frac = (rem / a) + '/' + (den / a);
    return whole === 0 ? frac : (whole + ' ' + frac);
  }

  window.wynFeed = {
    CFG: CFG,
    ageFactorFromMonths: ageFactorFromMonths,
    maintenanceKcal: maintenanceKcal,
    explain: explain,
    dietFactor: dietFactor,
    plan: plan,
    fmtOz: fmtOz,
    fmtCups: fmtCups,
    roundTo: roundTo
  };
})();